// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DtaThinkingStepsResponseThinkingStepsInner
 */
export interface DtaThinkingStepsResponseThinkingStepsInner {
    /**
     * 
     * @type {object}
     * @memberof DtaThinkingStepsResponseThinkingStepsInner
     */
    details?: object;
    /**
     * 
     * @type {number}
     * @memberof DtaThinkingStepsResponseThinkingStepsInner
     */
    duration_ms?: number;
    /**
     * 
     * @type {string}
     * @memberof DtaThinkingStepsResponseThinkingStepsInner
     */
    status: DtaThinkingStepsResponseThinkingStepsInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DtaThinkingStepsResponseThinkingStepsInner
     */
    step_description: string;
    /**
     * 
     * @type {string}
     * @memberof DtaThinkingStepsResponseThinkingStepsInner
     */
    step_name: string;
    /**
     * 
     * @type {string}
     * @memberof DtaThinkingStepsResponseThinkingStepsInner
     */
    timestamp: string;
}


/**
 * @export
 */
export const DtaThinkingStepsResponseThinkingStepsInnerStatusEnum = {
    Started: 'STARTED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;
export type DtaThinkingStepsResponseThinkingStepsInnerStatusEnum = typeof DtaThinkingStepsResponseThinkingStepsInnerStatusEnum[keyof typeof DtaThinkingStepsResponseThinkingStepsInnerStatusEnum];


/**
 * Check if a given object implements the DtaThinkingStepsResponseThinkingStepsInner interface.
 */
export function instanceOfDtaThinkingStepsResponseThinkingStepsInner(value: object): value is DtaThinkingStepsResponseThinkingStepsInner {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('step_description' in value) || value['step_description'] === undefined) return false;
    if (!('step_name' in value) || value['step_name'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    return true;
}

export function DtaThinkingStepsResponseThinkingStepsInnerFromJSON(json: any): DtaThinkingStepsResponseThinkingStepsInner {
    return DtaThinkingStepsResponseThinkingStepsInnerFromJSONTyped(json, false);
}

export function DtaThinkingStepsResponseThinkingStepsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DtaThinkingStepsResponseThinkingStepsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'details': json['details'] == null ? undefined : json['details'],
        'duration_ms': json['duration_ms'] == null ? undefined : json['duration_ms'],
        'status': json['status'],
        'step_description': json['step_description'],
        'step_name': json['step_name'],
        'timestamp': json['timestamp'],
    };
}

export function DtaThinkingStepsResponseThinkingStepsInnerToJSON(json: any): DtaThinkingStepsResponseThinkingStepsInner {
    return DtaThinkingStepsResponseThinkingStepsInnerToJSONTyped(json, false);
}

export function DtaThinkingStepsResponseThinkingStepsInnerToJSONTyped(value?: DtaThinkingStepsResponseThinkingStepsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'details': value['details'],
        'duration_ms': value['duration_ms'],
        'status': value['status'],
        'step_description': value['step_description'],
        'step_name': value['step_name'],
        'timestamp': value['timestamp'],
    };
}
